import { Link } from "react-router";
import { ShieldAlert } from "lucide-react";
import BasicLayout from "@/layouts/basic-layout";
import { ActionButton } from "@/dev/ui/verify-footer";
import SEO from "@/components/SEO";

export default function UnauthorizedPage() {
  return (
    <BasicLayout>
      <SEO title="אין הרשאה" path="/unauthorized" noindex />
      <main className="flex-grow  text-black">
        <div className="container mx-auto py-16 flex flex-col items-center justify-center">
          <ShieldAlert className="h-24 w-24 text-[#b65bf3] mb-6" />
          <h1 className="text-4xl font-bold mb-4">אין הרשאה</h1>
          <p className="text-xl mb-8 text-center max-w-md">
            אין לך הרשאה לצפות בתוכן זה. אנא התחבר שוב, או פנה למנהל המערכת לקבלת גישה.
          </p>
          <div className="flex gap-4 space-x-4 sm:space-x-0">
            <Link to="/login" className="">
              <ActionButton>התחברות</ActionButton>
            </Link>
            <Link to="/" className="">
              <ActionButton color="gray">חזרה לדף הבית</ActionButton>
            </Link>
          </div>
        </div>
      </main>
    </BasicLayout>
  );
}

export const ConflictPage = () => {
  return (
    <BasicLayout>
      {/* Unauthorized content */}

      <ShieldAlert className="h-24 w-24 text-[#b65bf3] mb-6" />
      <h1 className="text-4xl font-bold mb-4">אין הרשאה</h1>
      <p dir="rtl" className="text-xl mb-8 text-center max-w-md">
        הינך מחובר כבר ממכשיר אחר אנא התחבר שוב דרך מכשיר זה
      </p>
      <div className="flex gap-4 space-x-4 sm:space-x-0">
        <Link to="/login" className="">
          <ActionButton>התחברות</ActionButton>
        </Link>
        <Link to="/" className="">
          <ActionButton color="gray">חזרה לדף הבית</ActionButton>
        </Link>
      </div>
    </BasicLayout>
  );
};
